import React, { useState, useEffect } from 'react';
import './loading.css';
import { useDispatch, useSelector } from 'react-redux';
import { selectLoadingContext } from 'store/filters/selectors';
import { selectAiContext, selectSearchContext } from 'store/graph/selectors';
import { setIsLoadingGraphItems } from 'store/graph/actions';
import { cancelSearch } from 'store/core/actions';

const LOADING_STAGES = [
  'Initializing search',
  'Scanning database for connections',
  'Identifying key relationships',
  'Building primary nodes',
  'Mapping relationships',
  'Calculating edge weights',
  'Analyzing network patterns',
  'Optimizing graph layout',
  'Positioning nodes for best visibility',
  'Computing relationship distances',
  'Applying force-directed layout',
  'Detecting relationship clusters',
  'Finalizing node positions',
  'Rendering connections',
  'Polishing visualization',
  'Almost ready',
];

const SPINNER_GELS = [
  'center-gel',
  'c1 r1', 'c2 r1', 'c3 r1', 'c4 r1', 'c5 r1', 'c6 r1',
  'c7 r2', 'c8 r2', 'c9 r2', 'c10 r2', 'c11 r2', 'c12 r2',
  'c13 r2', 'c14 r2', 'c15 r2', 'c16 r2', 'c17 r2', 'c18 r2',
  'c19 r3', 'c20 r3', 'c21 r3', 'c22 r3', 'c23 r3', 'c24 r3',
  'c25 r3', 'c26 r3', 'c28 r3', 'c29 r3', 'c30 r3', 'c31 r3',
  'c32 r3', 'c33 r3', 'c34 r3', 'c35 r3', 'c36 r3', 'c37 r3',
];

const Loading = ({ thresholdExceeded }) => {
  const searchContext = useSelector(selectSearchContext);
  const viewContext = useSelector(selectLoadingContext);
  const aiContexts = useSelector(selectAiContext);
  const dispatch = useDispatch();
  const [loadingStage, setLoadingStage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setLoadingStage((prev) => (prev + 1) % LOADING_STAGES.length);
    }, 15000);

    return () => clearInterval(interval);
  }, []);

  const cancel = () => {
    dispatch(cancelSearch(true));
    dispatch(setIsLoadingGraphItems(false));
  };

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '48px',
      }}
    >
      <div className="socket">
        {SPINNER_GELS.map((gelClass) => (
          <div key={gelClass} className={`gel ${gelClass}`}>
            <div className="hex-brick h1"></div>
            <div className="hex-brick h2"></div>
            <div className="hex-brick h3"></div>
          </div>
        ))}
      </div>
      <div className="loading-search-name">
        <div className="loading-search-name-value">
          {searchContext.value || searchContext.metroRegion}
          {viewContext.value || viewContext.metroRegion}
        </div>
        <div className="loading-search-name-value-wrapper">
          {aiContexts.map((context, index) => (
            <div key={index} className="loading-search-name-value">
              {context.value || context.metroRegion}
            </div>
          ))}
        </div>
        <div
          style={{
            marginBottom: '16px',
            marginTop: '16px',
          }}
        >
          {LOADING_STAGES[loadingStage]}
        </div>

        {thresholdExceeded && (
          <div className="loading-threshold-message">
            Large network detected — we'll notify you when your map is ready
          </div>
        )}

        <div className="loading-search-cancel-value" onClick={cancel}>
          Cancel
        </div>
      </div>
    </div>
  );
};

export default Loading;
